import {useEffect, useRef} from 'react';
import {
  EVENT_TYPE,
  fireTabbedViewEvent
} from 'utils/metrics/pdpRelatedStylesTabbedView';

export default function useRelatedProductsAnalytics({
  isRecommendationsProductsFetched,
  isRelatedProductsFetched,
  tabsToShow
}) {
  const loadedEventFired = useRef(false);

  useEffect(() => {
    if (
      !loadedEventFired.current &&
      isRelatedProductsFetched &&
      isRecommendationsProductsFetched
    ) {
      loadedEventFired.current = true;
      fireTabbedViewEvent({
        availableTabs: tabsToShow.map((tab) => tab.value),
        eventType: EVENT_TYPE.LOADED
      });
    }
  }, [isRelatedProductsFetched, isRecommendationsProductsFetched, tabsToShow]);

  return {
    loadedEventFired
  };
}
